import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import mutations from './mutations';
import cacheInLocalStorage from './localCache/cacheInLocalStorage';
import cacheInSession from './localCache/cacheInSession';
import cacheInCookies from './localCache/cacheInCookies';
import moduleA from './modules/a';
import moduleB from './modules/b';

Vue.use(Vuex);

const initState = {
  token: cacheInLocalStorage.get('token') || '',
  user: cacheInLocalStorage.get('user') || {},
  userTab: cacheInSession.get('userTab') || '1',
  currentParkId: cacheInSession.get('currentParkId') || 1000,
  parkInfo: cacheInSession.get('parkInfo') || {parkName: '天安智慧云'},
  shoppingCart: cacheInLocalStorage.get('shoppingCart') || [],   // 保存购物车
  curPath: cacheInSession.get('curPath') || '',  // 保存当前路径
  parkServiceList: cacheInSession.get('parkServiceList') || [],  // 保存八大服务
};


export default new Vuex.Store({
  getters,
  mutations,
  state: initState,
  modules: {
    a: moduleA,
    b: moduleB,
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js